<template>

 <b-card bg-variant="light">
  <b-row>
    <b-col>
      <h4 class="text-secondary">Webshop</h4>
    </b-col>
    <b-col class="text-right" v-if="activated">
      <button v-for="locale in locales" :key="locale" @click="locale_selected = locale" class="btn  btn-sm mx-1" 
        :class="[locale_selected == locale ? 'btn-primary' : 'btn-secondary']"
      >
        {{ locale }}
      </button>
    </b-col>
  </b-row>
  <div  v-if="activated">
    <b-row>
      <b-col>
        <span>{{ $t("globals.title") }}:</span>
        <b-form-input v-model="shop[locale_selected]['title']" :disabled="!editable"></b-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span>{{ $t("globals.description") }}:</span>
        <b-form-textarea v-model="shop[locale_selected]['description']" rows="3" :disabled="!editable"></b-form-textarea>
      </b-col>
      
    </b-row>
    <b-row>
      <b-col class="mt-4 text-right">
        <b-button v-if="editable " @click="remove()" variant="warning" class="mr-4">{{ $t("globals.remove") }}</b-button>
        <b-button v-if="editable" @click="save()" variant="primary">{{ $t("globals.save") }}</b-button>
      </b-col> 
    </b-row>
    <b-row>
      <b-col>
        <h5 class="text-secondary">{{ $t("globals.add_photo") }}:</h5>
        
        <div v-for="(image, index) in shop.images" :key="index" style="display: inline-block; position: relative; margin: 5px;">
          <b-img v-if="image.id != null" :src="image.imageUrl" class="img-thumbnail mr-2 mb-2" style="max-width: 100px; max-height: 100px;" />
          <b-img v-else :src="image.data" class="img-thumbnail mr-2 mb-2" style="max-width: 100px; max-height: 100px;" />
          <button
            v-if="editable"
            @click="() => image.id != null ? removeImage(image.id) : removeImage(null, index)"
            class="btn btn-sm btn-danger"
            style="position: absolute; top: 0; right: 0; line-height: 1; padding: 2px 6px;"
          >
            ×
          </button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="editable">
        <input type="file" multiple @change="handlePhotoUpload" />
      </b-col>
    </b-row>
    
  </div>
  
 </b-card>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "WebshopItem",
  props: {
    item_id: {
      type: Number,
      required: true,
    },
    webshop_item: {
      type: Object,
      default: () => ({}),
    },
    default_title: {
      type: String,
      default: "",
    },
    parent_editable: {
      type: Boolean,
      required: true,
    },
    
  },

  components: {
    
  },
  data() {
    return {
      //locales:['en', 'nl'],
      locale_selected: 'en',
      shop: {},
      saving: false,
      temporal_image: ''
    };

  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch", "simpleMutation"]),
    parseRubyHashString(str) {
      if (!str) return {};

      try {
        const cleaned = str
          .replace(/=>/g, ':')
          .replace(/([a-z0-9_]+):/gi, '"$1":')
          .replace(/“|”/g, '"');
        return JSON.parse(cleaned);
      } catch (e) {
        console.error('Error parsing Ruby hash string:', str, e);
        return {};
      }
    },
    initShop() {
       
      const titles = (this.webshop_item && typeof this.webshop_item.title === 'object') ? this.webshop_item.title : {};
      const descriptions = (this.webshop_item && typeof this.webshop_item.description === 'object') ? this.webshop_item.description : {};
      const images = (this.webshop_item && Array.isArray(this.webshop_item.images)) ? this.webshop_item.images : [];

      this.shop = {}; 
      this.$set(this.shop, 'images', images);
      this.locales.forEach(local => {
        this.$set(this.shop, local, {
          title: titles[local] || this.default_title,
          description: descriptions[local] || '',
          images: images
        });
      });
      
    },
    
    save() {
      this.saving = true;
      const content = {};

      this.locales.forEach((local) => {
        content[local] = {
          title: this.shop[local].title || '',
          description: this.shop[local].description || '',
        };
      });
      
      // send just new images
      content['images'] = (this.shop.images || []).filter(image => image.data && image.new).map(image => image.data);
      content['remove_images'] = Array.isArray(this.shop.remove_images) ? this.shop.remove_images : [];
      

      const payload = {
        item_id: this.item_id,
        webshop_item_description:content,
      };

      let data = {
        query: `
          mutation WebshopItemUpsert($billing_item_id: Int!, $webshop_item_description: String!) {
            res: WebshopItemUpsert(billing_item_id: $billing_item_id, webshop_item_description: $webshop_item_description)
          }
        `,
        variables: {
          billing_item_id: this.item_id,
          webshop_item_description: JSON.stringify(payload.webshop_item_description)
        }
      };

      this.simpleMutation({data, this_ref: this}).then(() => {
        console.log('Webshop item saved successfully');
        // set all new images to false
        this.shop.images.forEach(image => image.new && (image.new = false));
        this.saving = false;
      });
     
    },

    remove() {
      
      let data = {
        query: `
          mutation WebshopItemRemove($billing_item_id: Int!) {
            res: WebshopItemRemove(billing_item_id: $billing_item_id)
          }
        `,
        variables: {
          billing_item_id: this.item_id
        }
      };

      this.simpleMutation({data, this_ref: this}).then(() => {

        
        this.locales.forEach(local => {
          this.$set(this.shop, local, {
            title: this.default_title,
            description: ''
          });
        });
        this.locale_selected = 'en';
        
        
      });
    },

    handlePhotoUpload(e) {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        if (!this.shop.images) this.shop.images = [];
        this.shop.images.push({id: null, data:event.target.result, new: true});
      };
      reader.readAsDataURL(file);
      
    },
    removeImage(id, index =null) {
      if (!this.shop.images || !Array.isArray(this.shop.images)) return;
      
      if (index !== null) {
        this.shop.images.splice(index, 1);
      } else if (id != null) {
        this.shop.images = this.shop.images.filter(image => image.id !== id);
        if (!Array.isArray(this.shop.remove_images)) {
          this.shop.remove_images = [];
        }

        this.shop.remove_images.push(id);
      }
      
    }

  },
  computed: {
   

    editable(){
      return this.parent_editable && !this.saving ? true : false;
    },
    locales(){
      return this.webshop_item && this.webshop_item.locales ? this.webshop_item.locales : ['en', 'nl'];
    },
    activated() {
      return (this.webshop_item && Object.keys(this.webshop_item).length > 0) || this.editable;
    },
    

    
  },
  created() {
    this.initShop();
  },
  watch: {
    webshop_item: {
      handler() {
        this.initShop();
      },
      deep: true,
      immediate: true,
    },
  },
  
};
</script>